import { Modal, PDFRenderer } from "components";
import { useMatch, useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import config from "config";
import _ from "lodash";
import { useTreaty } from "hooks/data/use-treaties";
import { getLayerParticipantsPercentageTotal } from "utils";
import { useCurrentUser } from "_graphql/cache/auth";

export default function ViewLayerLimitDebitNoteContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const currentUser = useCurrentUser();
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();
  const { loading, treaty } = useTreaty({ treatyId: params?.treaty });

  const layer: any = JSON.parse(treaty?.layer_limit || "[]")?.at(
    Number(searchParams?.layer) - 1
  );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      hidePadding
      size="6xl"
      title="Debit Note"
      description={`Details of debit note shown below`}
    >
      <PDFRenderer
        url={`${config.asset.uri}treaty_np_debit_note/${btoa(
          JSON.stringify({
            treaty_id: params?.treaty,
            limit: layer?.limit,
            layer: layer?.no - 1,
            m_and_d_premium: layer?.m_and_d_premium,
            total_participation_percentage: getLayerParticipantsPercentageTotal(
              treaty,
              Number(searchParams?.layer)
            ),
            installment_type: layer?.installment_type,
            emp_id: currentUser?.employee?.employee_id,
          })
        )}`}
      />
    </Modal>
  );
}
